module.exports = __webpack_public_path__ + "img/branch.f6d77b7a.svg";